import { axios } from '@Root/API'

export const getAttachedStudents = (programmeId, params) => {
	return axios.get(`student/attache/program/${programmeId}`, { params })
}
